import React , {useState , useEffect} from 'react';
import { Link  ,useHistory } from 'react-router-dom';
import swal from 'sweetalert';


import logo1 from '../assets/images/logo-kar1.png';

import { useSelector, useDispatch } from 'react-redux';

import Loader from "react-loader-spinner";

import FavoriteIcon from '@material-ui/icons/Favorite';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';


const Header =(props)=> {

  const [total1 , settotal1] = useState(0)
    const [search , setSearch] = useState("")
    const [price , setPrice] = useState([1,1,1,1,1,1,1,1,1,1,1,1,1])
    const [peice , setpeice] = useState([1,1,1,1,1,1,1,1,1,1,1,1,1])
    const [DataPart2 , setDataPart2] = useState([])
    const [UserDatat , setUserDatat] = useState({})
    const [userHeader , setuserHeader] = useState(false)
    const [menu1 , setmenu1] = useState(false)
    const [adminHeader , setadminHeader] = useState(false)
    const [displayMenu , setdisplayMenu] = useState(false)
    const [MainLine , setMainLine] = useState("")
    const [MainForum , setMainForum] = useState(false)
    const [MainCatogories , setMainCategories] = useState([





      
      

//   {
//         "_id": "6797ca68fcb322000cf4c98f",
//         "MainCategories": "Indoor Plant",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(2)%20Indoor%20plants.png?updatedAt=1752058756335",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "6798cc16071fed000c46cfe3",
//         "MainCategories": "Outdoor Plant",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(6)%20outdoor%20plants.png?updatedAt=1752058842141",
//         "sort": 1,
//         "__v": 0
//     },
//      {
//         "_id": "679b43081c6b24000c26d3a3",
//         "MainCategories": "Plant bundles",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(1)%20Plant%20bundles.png?updatedAt=1752058726741",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "679b5a7faeab27000cdc8195",
//         "MainCategories": " Flower Bouquets",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(5)%20Flower%20Bouquets.png?updatedAt=1752058810775",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "6799e004bcf8b2000c638f78",
//         "MainCategories": "Exotic plants",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(7)%20Exotic%20plants.png?updatedAt=1752058864372",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "679b3255b2f331000c953c94",
//         "MainCategories": "Artificial plants",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(4)%20Artificial%20plants.png?updatedAt=1752058792035",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "679b326ab2f331000c953c95",
//         "MainCategories": "Pots and planters",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(3)%20pots%20and%20planters.png?updatedAt=1752058775430",
//         "sort": 1,
//         "__v": 0
//     },
   
//     {
//         "_id": "679c5b44033385000c3a801d",
//         "MainCategories": "Garden Accessories",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(15)%20Garden%20accessories.png?updatedAt=1752060295555",
//         "sort": 1,
//         "__v": 0
//     }








    ])
    const [SubCategories , setSubCategories] = useState([])
    const [SubClassCategories , setSubClassCategories] = useState([])
    const [fvalue , setfvalue] = useState([







//   {
//         "_id": "6797ca68fcb322000cf4c98f",
//         "MainCategories": "Indoor Plant",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(2)%20Indoor%20plants.png?updatedAt=1752058756335",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "6798cc16071fed000c46cfe3",
//         "MainCategories": "Outdoor Plant",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(6)%20outdoor%20plants.png?updatedAt=1752058842141",
//         "sort": 1,
//         "__v": 0
//     },
//      {
//         "_id": "679b43081c6b24000c26d3a3",
//         "MainCategories": "Plant bundles",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(1)%20Plant%20bundles.png?updatedAt=1752058726741",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "679b5a7faeab27000cdc8195",
//         "MainCategories": " Flower Bouquets",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(5)%20Flower%20Bouquets.png?updatedAt=1752058810775",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "6799e004bcf8b2000c638f78",
//         "MainCategories": "Exotic plants",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(7)%20Exotic%20plants.png?updatedAt=1752058864372",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "679b3255b2f331000c953c94",
//         "MainCategories": "Artificial plants",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(4)%20Artificial%20plants.png?updatedAt=1752058792035",
//         "sort": 1,
//         "__v": 0
//     },
//     {
//         "_id": "679b326ab2f331000c953c95",
//         "MainCategories": "Pots and planters",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(3)%20pots%20and%20planters.png?updatedAt=1752058775430",
//         "sort": 1,
//         "__v": 0
//     },
   
//     {
//         "_id": "679c5b44033385000c3a801d",
//         "MainCategories": "Garden Accessories",
//         "photo": "https://ik.imagekit.io/ynxypworn/io%20(15)%20Garden%20accessories.png?updatedAt=1752060295555",
//         "sort": 1,
//         "__v": 0
//     }








    ])
    const [fvalue1 , setfvalue1] = useState([])
    const [fg , setfg] = useState(true)
    const [abc , setabc] = useState(false)
    const [DisplaySearch , setDisplaySearch] = useState(false)
    const [DisplayMenu , setDisplayMenu] = useState(false)
    const [bht , setbht] = useState("")
    const [mainUser , setmainUser] = useState({})
    const [couponShow1 , setcouponShow1] = useState(false)
    const [name, setname] = useState("") 
    const [email, setemail] = useState("") 
    const [message, setmessage] = useState("") 
    const [photo, setphoto] = useState("") 
    const [allmessage , setallmessage] = useState([])
    const [cart1 , setcart1] = useState([])
    const [fav1 , setfav1] = useState([])
    const [dis , setdis] = useState(true)
    const [Dis1 , setDis1] = useState(false)
    
    // const [photo, setphoto] = useState("") 

    let history = useHistory();


    useEffect(() =>{
      document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
      document.getElementById("menu-mobile-1").style.visibility = "hidden"
      document.getElementById("menu-mobile-2").style.visibility = "hidden"
      var data1 =  JSON.parse(localStorage.getItem("Cart")) && JSON.parse(localStorage.getItem("Cart")).length > 0 ?  JSON.parse(localStorage.getItem("Cart"))  : []
      var data2 =  JSON.parse(localStorage.getItem("Fav")) ?  JSON.parse(localStorage.getItem("Fav")) : []
      if(JSON.parse(localStorage.getItem("Cart")) && JSON.parse(localStorage.getItem("Cart")).length > 0 ){
        localStorage.setItem("Carts",JSON.stringify(
          JSON.parse(localStorage.getItem("Cart"))
        ))
      }
      setcart1(data1)
      setfav1(data2)
      // let data5 =  JSON.parse(localStorage.getItem("CartPrice")) 
      // settotal1(data5)
      let j = 0 
      data1.map((item,i)=>{
        j = item.Total_Product_Price + j
     })
     settotal1(j)
        if( JSON.parse(localStorage.getItem("user main")) ) setmainUser(JSON.parse(localStorage.getItem("user main")))
 

        fetch("https://paint-saudi-rayidh-main-back.vercel.app/MainCatogories",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res3=>res3.json())
        .then(res4=>{
            let dat = []
            let dat1 = []
            res4.map((res55,c)=>{
                dat.push(res55)
                dat1.push(0)
            })
                        console.log(dat)
            let data = dat.sort((a, b) => {
                return a.sort - b.sort;
            });
            setMainCategories(data)
            console.log(data)
            setfvalue(dat1)
        })
    
        const inter = setInterval(()=>{



          



          // console.log(JSON.parse(localStorage.getItem("Cart")).length, JSON.parse(localStorage.getItem("Carts")).length)
          if(JSON.parse(localStorage.getItem("Cart")) && JSON.parse(localStorage.getItem("Cart")).length > 0){
            JSON.parse(localStorage.getItem("Cart")).map((res,y)=>{
              if(JSON.parse(localStorage.getItem("Carts"))&& JSON.parse(localStorage.getItem("Carts"))[y]){
                console.log(res.Pieces , JSON.parse(localStorage.getItem("Carts"))[y].Pieces)
                if(res.Pieces === JSON.parse(localStorage.getItem("Carts"))[y].Pieces){

              }
              else{
                removeDatas1()
                localStorage.setItem("Carts",JSON.stringify(
                  JSON.parse(localStorage.getItem("Cart"))
                ))
                return
              }
            }
            else{
              removeDatas1()
              localStorage.setItem("Carts",JSON.stringify(
                JSON.parse(localStorage.getItem("Cart"))
              ))
              return
              }
              
            })

          }
          
          var data1 =  JSON.parse(localStorage.getItem("Cart")) 
          if (data1) {

           setcart1( data1)
             setDataPart2(data1)

          
            let j = 0 
            data1.map((res,i)=>{
              peice[i] = res.Pieces
              price[i] = res.Pieces
              j = res.Total_Product_Price + j
            })
            
            settotal1(j)




            }
         else setDataPart2(0)
            var data6 =  JSON.parse(localStorage.getItem("Fav")) 
         if (data6) {
             setfav1(data6)
            //  const data = DataPart2.length  
            //  setfav1(data)
            }
         else setfav1(0)

         if( JSON.parse(localStorage.getItem("user main")) ) setmainUser(JSON.parse(localStorage.getItem("user main")))
        
       

        },3000)
        
        return () => clearInterval(inter);
    },[])
  







    

  const minus=(e)=>{
    if(peice[e] > 1){
      peice[e] = (peice[e] - 1)
    // console.log(peice[e],peice);
    if(dis)
    setdis(true)
    else setdis(false)}


    

   let d =  cart1.map((res,i)=>{
    if(i == e){
       console.log(i , e)
       return {...res,Total_Product_Price : res.Product_Price_Discounted * (res.Pieces-1), Pieces : res.Pieces-1}
     }
     else{
       return res
     }
    })
   localStorage.setItem("Cart",JSON.stringify(d)) 
    setcart1(d)
console.log(d,cart1)

var j = 0
d.map((item,i)=>{
   j = item.Total_Product_Price + j
})
settotal1(j)
localStorage.setItem("CartPrice" ,JSON.stringify(j))


    }
    

const plus=(e)=>{
    if(peice[e] < 100)
    peice[e] = (peice[e] + 1)
    // console.log(peice[e],peice);
    if(dis)
    setdis(true)
    else setdis(false)



   let d =  cart1.map((res,i)=>{
     if(i == e){
        console.log(i , e)
        return {...res,Total_Product_Price : res.Product_Price_Discounted * (res.Pieces+1), Pieces : res.Pieces+1}
      }
      else{
        return res
      }
     })
    localStorage.setItem("Cart",JSON.stringify(d)) 
     setcart1(d)
console.log(d,cart1)

var j = 0
d.map((item,i)=>{
   j = item.Total_Product_Price + j
})
settotal1(j)
localStorage.setItem("CartPrice" ,JSON.stringify(j))


}





const removeDatas = (item) =>{
 
  let data1;
  if(!item.Size){
       data1 = cart1.filter((res,i)=>{
          return res._id !== item.id
      })
  }
  else{
       data1 = cart1.filter((res,i)=>{
          return res.Size !== item.Size
      })
  }
  localStorage.setItem("Cart" ,JSON.stringify(data1))
      var j = 0
  data1.map((res,i)=>{
       j += res.Total_Product_Price
  })
  if ( j !== 0){
      localStorage.setItem("CartPrice",JSON.stringify( j))
      settotal1(j)
  }
  else{
      localStorage.setItem("CartPrice",JSON.stringify( 0))
      settotal1(0)
  }
  
  
}



const removeDatas1 = () =>{
 
  setDis1(!Dis1)
  
}










    const SubmitData45342 = (e) =>{
      e.preventDefault()
      console.log("df")
      setDisplaySearch(true)
      localStorage.removeItem("SearchData")
          fetch("https://paint-saudi-rayidh-main-back.vercel.app/SearchProduct",{
                                  method: "POST",
                                  headers :  {
                                      "Content-Type" : "application/json" , 
                                  } ,
                                  body : JSON.stringify({
                                      search : search.toLowerCase() ,
      
                                  })
                              })
                              .then(res=>res.json())
                              .then((res1)=>{ 
                                
                                console.log(res1) 
                                  const SearchProductItem = []
                                  
                                  let search1 = search.split(" ")
                                res1.map((res2,i)=>{
                                    // console.log(res2.Product_Name.toLowerCase().split(" "),res2.Product_Title.toLowerCase().split(" "),i)
                                    var Name = res2.Product_Name.toLowerCase().split(" ")
                                     var Title = res2.Product_Title.toLowerCase().split(" ")
                                    // console.log(Name , Title)
                                    for (let j = 0; j < search1.length; j++) {
                                      
                                      Name.map((res3,i)=>{
  
                                          if (res3 === search1[j].toLowerCase().trim()){
                                              SearchProductItem.unshift(res2)
                                          }
                                      })
                                      Title.map((res4,i)=>{
                                        if (res4 === search1[j].toLowerCase().trim()){
                                          SearchProductItem.unshift(res2)
                                        }
                                      })
                                    }
                                })
                                  console.log(SearchProductItem)    

                                  console.log(SearchProductItem,props)
                                  let uniq = [...new Set(SearchProductItem)];
      
                                  localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                  
                                  setDisplaySearch(false)
                                  setTimeout(()=>{
                                      history.push("/search/product-item");
      
                                      // return <Redirect push to="/shop/search/product-item" /> 
                                      // props.history.push(`/shop/search/product-item`)
                                  },1000)   
                                  // localStorage.setItem("SearchData" , JSON.stringify(res1) )
                                  // props.history.push(`/shop/search/product-item`)
      
                                  
                          })
                          .catch(err=>{
                            console.log(err)
                            swal("There is An Error")                  
                            setDisplaySearch(false)
                              }) 
      }

    
const setDisplayMenu3 =() =>{
  if(document.getElementById("menu-mobile-1").style.visibility === "hidden"){
    document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
    document.getElementById("menu-mobile-1").style.visibility = "visible"
    document.getElementById("menu-mobile-2").style.visibility = "visible"
  }
  else{
    document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
    document.getElementById("menu-mobile-1").style.visibility = "hidden"
    document.getElementById("menu-mobile-2").style.visibility = "hidden"
  }
}
    
    
const setChangeDrop =() =>{
 console.log("dffdf")
//  document.getElementsByClassName('dropdown-menu')[0].style.visibility = "hidden"
//  document.getElementsByClassName('dropdown-menu')[0].style.opacity = 1

    document.getElementById("drop-change").style.visibility = "hidden"
    document.getElementById("drop-change").style.opacity = 1

}
const setChangeDrop1 =() =>{
 console.log("dffdf")
//  document.getElementsByClassName('dropdown-menu')[0].style.visibility = "hidden"
//  document.getElementsByClassName('dropdown-menu')[0].style.opacity = 1

    // if(document.getElementById("drop-change").style.visibility === "hidden"){
      document.getElementById("drop-change").style.visibility = "visible"
      document.getElementById("drop-change").style.opacity = 1
    // }

}
        return (
            <>
             { DisplaySearch ?
                <Loader
        type="Puff"
        color="#00BFFF"
        height={100}
        width={100}
        timeout={10000} //3 secs
        className="loader-1"
      /> 
      :""
}  


{/* 
{

Dis1 
?

<div className='sdjkjkjk' style={{height: "100vh",width: "32%",position: "fixed",right: "0px",background: "white",zIndex: "99999",boxShadow:"-2px 3px 4px grey"}}>








<nav aria-label="breadcrumb" className="breadcrumb-nav">
              <div className="container">
                <ol className="breadcrumb" style={{display:"flex",justifyContent:"space-between"}}>
                  <li className="breadcrumb-item active" aria-current="page"  style={{color :  "black",fontSize:"18px",fontWeight:"700",fontFamily:"cursive"}}>Shopping Cart
                  </li>
                  <button className="btn-remove"  onClick={()=>removeDatas1()} ><i className="icon-close" style={{color:"black",fontWeight:"bold",fontSize:"x-large"}}/></button>
                </ol>
                  <p style={{fontWeight:"500",paddingLeft:"14px",color:"grey"}}>{cart1.length} items  </p> 
              </div>
            </nav>
            <div className="page-content" style={{height:"100%"}}>
              <div className="cart" style={{height:"100%"}}>
                <div className="container" style={{height:"100%"}}>
                  <div style={{display: "flex"
,
    justifyContent: "center"}}>
                    <div style={{ maxHeight: "100%",
    overflow: "hidden"}}>
                      {cart1 && cart1.length !== 1 ?
                      <table className="table table-cart table-mobile hhjjhhjhj" style={{overflow: "scroll",
    maxHeight: "39%"}}>
<tbody  style={{overflow: "scroll",
    maxHeight: "39%"}}>
                        {
                          cart1.length >= 1 ? cart1.map((item,i)=>{
                            return(

                              <tr>
                                <td className="product-col" style={{padding : "0px 0px"}}>
                                  <div className="product hhjhjh">
                                    <figure className="product-media">
                                      <a >
                                        <img src={item.Product_Image_Upload} alt="Product image"  onClick={()=>props.history.push("/categories/"+item.Product_Catagories+"/"+item.Product_Sub_Catagories+"/"+item.Course_Sub_Catagories+"/all-products/"+item.Product_Name+"/"+item._id)} />
                                      </a>
                                    </figure>
                                    <h3 className="product-title" style={{padding :"0px"}}>
                                      <div style={{overflow : "hidden" , height:"114px"}}>
                                      <a >{item.Product_Name}</a>
<br />
<br />
                                      {item.Product_Price_Discounted ?
                                      <div class="product-price"  style={{justifyContent :"flex-start",marginBottom : "15px"}}>
                      <span class="old-price" style={{fontSize : "12px",  marginRight:"12px",  textDecoration: "line-through",color:"#ddd9d9"}}>Rs.{(item.Product_Price)}.00</span>
                        <span class="new-price" style={{fontSize : "14px",fontWeight:"700",color:"#e10600"}}>Rs.{(item.Product_Price_Discounted)}.00</span>
                       
                    
                    </div>
                            :            
                                      <div class="product-price"  style={{justifyContent :"flex-start",marginBottom : "15px"}}>
                        <span class="new-price" style={{fontSize : "14px",fontWeight:"700",color:"black"}}>Rs.{(item.Product_Price)}.00</span>
                       
                    
                    </div>
                                      }

                                      <div class="product-details-quantity quantity-centered">
                                  <div class="input-group input-spinner">
                                    <div class="input-group-prepend">
                                      <button style={{minWidth: "26px"}} class="btn btn-decrement btn-spinner" type="button" onClick={()=>minus(i)} ><i class="icon-minus"></i>
                                      </button>
                                    </div>
                                    <input type="text" style={{textAlign: "center"}} class="form-control " required placeholder=""   value={peice[i]} size={4} defaultValue={1} min={0} step={1}/>
                                    <div class="input-group-append">
                                      <button style={{minWidth: "26px"}} class="btn btn-increment btn-spinner" type="button"  onClick={()=>plus(i)}><i class="icon-plus"></i>
                                      </button>
                                    </div>
                                    </div>
                                </div>

                                      </div>
                                    </h3>
                                  </div>
                                </td>



                              
                                <td className="remove-col"><button className="btn-remove"  onClick={()=>removeDatas(item)} style={{paddingLeft:"2px"}}><i className="icon-close" /></button></td>
                              </tr>



                          )
                        })
                        : <tr><td colSpan="6"><div className="col-sm-12 col-lg-12 mb-12"><center> <h3> No Product in Cart</h3></center> </div></td></tr> 
                      }

                          



                          
                        </tbody>
                      </table>
      :
                      <table className="table table-cart table-mobile hhjjhhjhj" style={{overflow: "scroll",
    maxHeight: "100%"}}>
<tbody>
                        {
                          cart1.length >= 1 ? cart1.map((item,i)=>{
                            return(

                              <tr>
                                <td className="product-col"  style={{padding : "0px 0px"}}>
                                  <div className="product hhjhjh">
                                    <figure className="product-media">
                                      <a >
                                        <img src={item.Product_Image_Upload} alt="Product image"  onClick={()=>props.history.push("/categories/"+item.Product_Catagories+"/"+item.Product_Sub_Catagories+"/"+item.Course_Sub_Catagories+"/all-products/"+item.Product_Name+"/"+item._id)} />
                                      </a>
                                    </figure>
                                    <h3 className="product-title" style={{padding :"0px"}}>
                                      <div style={{overflow : "hidden" , height:"114px"}}>
                                      <a >{item.Product_Name}</a>
<br />
<br />
                                      {item.Product_Price_Discounted ?
                                      <div class="product-price"  style={{justifyContent :"flex-start",marginBottom : "15px"}}>
                      <span class="old-price" style={{fontSize : "12px",  marginRight:"12px",  textDecoration: "line-through",color:"#ddd9d9"}}>Rs.{(item.Product_Price)}.00</span>
                        <span class="new-price" style={{fontSize : "14px",fontWeight:"700",color:"#e10600"}}>Rs.{(item.Product_Price_Discounted)}.00</span>
                       
                    
                    </div>
                            :            
                                      <div class="product-price"  style={{justifyContent :"flex-start",marginBottom : "15px"}}>
                        <span class="new-price" style={{fontSize : "14px",fontWeight:"700",color:"black"}}>Rs.{(item.Product_Price)}.00</span>
                       
                    
                    </div>
                                      }

                                      <div class="product-details-quantity quantity-centered">
                                  <div class="input-group input-spinner">
                                    <div class="input-group-prepend">
                                      <button style={{minWidth: "26px"}} class="btn btn-decrement btn-spinner" type="button" onClick={()=>minus(i)} ><i class="icon-minus"></i>
                                      </button>
                                    </div>
                                    <input type="text" style={{textAlign: "center"}} class="form-control " required placeholder=""   value={peice[i]} size={4} defaultValue={1} min={0} step={1}/>
                                    <div class="input-group-append">
                                      <button style={{minWidth: "26px"}} class="btn btn-increment btn-spinner" type="button"  onClick={()=>plus(i)}><i class="icon-plus"></i>
                                      </button>
                                    </div>
                                    </div>
                                </div>

                                      </div>
                                    </h3>
                                  </div>
                                </td>



                              
                                <td className="remove-col"><button className="btn-remove"  onClick={()=>removeDatas(item)} style={{paddingLeft:"2px"}} ><i className="icon-close" /></button></td>
                              </tr>



                          )
                        })
                        : <tr><td colSpan="6"><div className="col-sm-12 col-lg-12 mb-12"><center> <h3> No Product in Cart</h3></center> </div></td></tr> 
                      }

                          



                          
                        </tbody>
                      </table>
                      }
                       
                        <div style={{ }}>
                      <div className="summary summary-cart" style={{margin:"0px"}}>
                        <table className="table table-summary">
                          <tbody>
                            <tr className="summary-subtotal summary-subtotal1">
                              <td>Subtotal:</td>
                              <td>SAR. {total1
}.00</td>
                            </tr>
                                                     <tr className="summary-total summary-subtotal1">
                              <td>Total :</td>
                              <td>SAR.  
    {total1}.00
 
            </td>
                            </tr>
                          </tbody>
                        </table>
                        <Link to="/checkout" className="btn btn-outline-primary-2 btn-order btn-block">PROCEED TO CHECKOUT</Link>
                      </div>
                      <Link to="/"  className="btn btn-outline-dark-2 btn-block mb-3"><span>CONTINUE SHOPPING</span><i className="icon-refresh" /></Link>
                    </div>
                    <td id="discount" style={{color:"white",display:"none"}}></td>

                    </div>
                    
                  </div>
                </div>
              </div>
            </div>










</div>

: ""
} */}



<header className="header header-intro-clearance header-26">
              <div className="header-top">
                <div>
                  <div>
                    <marquee behavior="" direction="">
                   <center>
                    <span  className="" style={{color : "black"}}>
ألوان تُغيّر منزلك… ومواد عالية الجودة بانتظارك — اطلب الآن!




                      </span>
                   </center>
                    
                    </marquee>
                   

                  </div>
                
                </div>
                {/* End .container */}
              </div>
              {/* End .header-top */}
              <div className="header-middle">
                <div className="container">
                  <div className="header-left">
                    <button className="mobile-menu-toggler" onClick={()=>setDisplayMenu3()}>
                      <span className="sr-only">Toggle mobile menu</span>
                      <i className="icon-bars" />
                    </button>
                    <Link to="/" className="logo">
                      <img src={logo1} alt="Dubai Plant Shop Logo" width={185} height={25}  style={{paddingBottom: "11px"}}/>
                    </Link>
                  </div>
                  {/* End .header-left */}
                  <div className="header-center">
                    <div className="header-search header-search-visible header-search-no-radius">
                      <span  className="search-toggle" role="button">
                        <i className="icon-search" style={{transform: "rotate(280deg)"}} />
                      </span>
                      <form onSubmit={(e)=>SubmitData45342(e)}>
                        <div className="header-search-wrapper search-wrapper-wide">
                         
                          {/* End .select-custom */}
                          <label htmlFor="q" className="sr-only">Search</label>
                          <input type="search" className="form-control" name="q" id="q" required value={search} onChange={(e)=>setSearch(e.target.value)}  style={{ }} placeholder="ابحث عن العلامات التجارية، الفئات، المنتجات، رقم SKU..."/>
                          <button className="btn btn-primary" type="submit">
                            <i className="icon-search" style={{transform: "rotate(280deg)"}} />
                          </button>
                        </div>
                        {/* End .header-search-wrapper */}
                      </form>
                    </div>
                    {/* End .header-search */}
                  </div>
                  <div className="header-right">
                    <div className="header-dropdown-link">
                     
                      <div className="wishlist">
                        <Link to="/whislist" title="Wishlist">
                          <div className="icon">
                            <i className="icon-heart-o" />
                            <span className="wishlist-count badge">{ fav1 ? fav1.length : 0}</span>
                          </div>
                          <p>المفضلة</p>
                        </Link>
                      </div>
                      {/* End .compare-dropdown */}
                      <div className="dropdown cart-dropdown">
                        <Link to="/cart" className="dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static" >
                          <div className="icon" onMouseEnter={()=>setChangeDrop1()} onMouseLeave={()=>setChangeDrop()}>
                            <i className="icon-shopping-cart" />
                            <span className="cart-count">{ cart1 ? cart1.length :0}</span>
                          </div>
                          <p>سلة التسوق</p>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right" id="drop-change"  onMouseEnter={()=>setChangeDrop1()} onMouseLeave={()=>setChangeDrop()}>
                          <div className="dropdown-cart-products">


                          {
                          cart1.length >= 1 ? cart1.map((item,i)=>{
                            return(
                                <div className="product">
                                  <div className="product-cart-details">
                                    <h4 className="product-title letter-spacing-normal font-size-normal">
                                      <Link to={"/categories/"+item.Product_Catagories+"/"+item.Product_Sub_Catagories+"/"+item.Course_Sub_Catagories+"/all-products/"+item.Product_Name+"/"+item._id}>{item.Product_Name}</Link>
                                    </h4>
                                    <span className="cart-product-info">
                                      <span className="cart-product-qty">{item.Pieces}</span>
                                      x SAR. {(item.Total_Product_Price /  item.Pieces ).toFixed(0)}
                                    </span>
                                  </div>
                                  {/* End .product-cart-details */}
                                  <figure className="product-image-container">
                                    <Link to={"/categories/"+item.Product_Catagories+"/"+item.Product_Sub_Catagories+"/"+item.Course_Sub_Catagories+"/all-products/"+item.Product_Name+"/"+item._id}>
                                      <img src={item.Product_Image_Upload} alt="Product image"  onClick={()=>props.history.push("/categories/"+item.Product_Catagories+"/"+item.Product_Sub_Catagories+"/"+item.Course_Sub_Catagories+"/all-products/"+item.Product_Name+"/"+item._id)} width={200} height={300} />
                                    </Link>
                                  </figure>
                                 
                              </div>

                              )
                            })
                            : <span style={{textAlign : "center"}}>سلة التسوق فارغة</span>
                          }
    

                            
                          </div>
                          {/* End .cart-product */}
                          {/* <div className="dropdown-cart-total">
                            <span>Total</span>
                            <span className="cart-total-price">$
                            {(total1).toFixed(0)

} 
                            </span>
                          </div> */}
                          {/* End .dropdown-cart-total */}
                          <div className="dropdown-cart-action">
                            <Link to="/cart" className="btn btn-outline-primary-2" onClick={()=>setChangeDrop()}>عرض السلة</Link>
                            <Link to="/checkout" className="btn btn-outline-primary-2" onClick={()=>setChangeDrop()}>
                              <span>إتمام الشراء</span>
                              <i className="icon-long-arrow-right" />
                            </Link>
                          </div>
                          {/* End .dropdown-cart-total */}
                        </div>
                        {/* End .dropdown-menu */}
                      </div>
                      {/* End .cart-dropdown */}
                    </div>
                  </div>
                  
                  {/* End .header-right */}
                </div>
                
                {/* End .container */}
              </div>

              {/* End .header-middle */}









              <div className="header-top">
                <div className="container">
                <form onSubmit={(e)=>SubmitData45342(e)} className="mobile-search mobile-search1">
                <label htmlFor="mobile-search" className="sr-only">Search</label>
                <input type="search" name="mobile-search" id="mobile-search" required value={search} onChange={(e)=>setSearch(e.target.value)} style={{width: "100%",color : "black",background : "white" , border : " none"}} placeholder="ابحث عن العلامات التجارية، الفئات، المنتجات، رقم SKU..."/>
                <button className="btn btn-primary" type="submit">
                  <i className="icon-search" style={{transform: "rotate(280deg)"}} />
                </button>
              </form>
                  
                  {/* End .header-right */}
                </div>
                {/* End .container */}
              </div>

































              <div className="mobile-menu-overlay" />
          <div className="mobile-menu-container" id="menu-mobile-1">
            <div className="mobile-menu-wrapper">
              <span className="mobile-menu-close"  onClick={()=>setDisplayMenu3()}>
                <i className="icon-close" />
              </span>
            
              <ul className="nav nav-pills-mobile" role="tablist">
                <li className="nav-item">
                  <a className="nav-link font-size-normal second-primary-color font-weight-normal text-uppercase active" id="mobile-cats-link" data-toggle="tab" href="#mobile-cats-tab" role="tab" aria-controls="mobile-cats-tab" aria-selected="false">Categories</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link font-size-normal second-primary-color font-weight-normal text-uppercase" id="mobile-menu-link" data-toggle="tab" href="#mobile-menu-tab" role="tab" aria-controls="mobile-menu-tab" aria-selected="true">Menu</a>
                </li>
              </ul>
              <div className="tab-content">
                <div className="tab-pane fade" id="mobile-menu-tab" role="tabpanel" aria-labelledby="mobile-menu-link">
                  <nav className="mobile-nav">
                    <ul className="mobile-menu">
  <li className="active">
    <Link onClick={()=>setDisplayMenu3()} to="/">الرئيسية</Link>
  </li>

  <li>
    <Link onClick={()=>setDisplayMenu3()} to="/product/new-arrival">أفضل عروض اليوم</Link>
  </li>

  <li>
    <Link onClick={()=>setDisplayMenu3()} to="/product/expert-pick">
      <span>الأكثر رواجًا
        <span className="tip tip-hot">ساخن</span>
      </span>
    </Link>
  </li>

  <li>
    <Link onClick={()=>setDisplayMenu3()} to="/product/recommended-product">منتجات مميزة</Link>
  </li>

  <li>
    <Link onClick={()=>setDisplayMenu3()} to="/product/recommended-product">
      <span>منتجات موصى بها
        <span className="tip tip-new">جديد</span>
      </span>
    </Link>
  </li>

  <li>
    <Link onClick={()=>setDisplayMenu3()} to="/cart">سلة التسوق</Link>
  </li>

  <li>
    <Link onClick={()=>setDisplayMenu3()} to="/checkout">الدفع</Link>
  </li>

  <li>
    <Link onClick={()=>setDisplayMenu3()} to="/whislist">قائمة الرغبات</Link>
  </li>

  <li>
    <Link onClick={()=>setDisplayMenu3()} to="/contact">تواصل معنا</Link>
  </li>
</ul>

                  </nav>
                  {/* End .mobile-nav */}
                </div>
                {/* .End .tab-pane */}
                <div className="tab-pane fade show active" id="mobile-cats-tab" role="tabpanel" aria-labelledby="mobile-cats-link">
                  <nav className="mobile-cats-nav">
                    <ul className="mobile-cats-menu">
                    {MainCatogories.map((res,i)=>{
                    
               
                 return (
              <>
                  <li>
                    <a  className="mobile-cats-lead" href={"/categories/"+res.MainCategories+"/all-products" }>
                       {res.MainCategories}</a>
                  </li>
               </>
                 )
              
                  
                  })
                

                              }
            
                    </ul>
                    {/* End .mobile-cats-menu */}
                  </nav>
                  {/* End .mobile-cats-nav */}
                </div>
                {/* .End .tab-pane */}
              </div>
              {/* End .tab-content */}
              <div className="social-icons justify-content-center">
                <a href="https://www.facebook.com/Malook.Official/" className="social-icon" target="_blank" title="Facebook">
                  <i className="icon-facebook-f" />
                </a>
               
                <a href="https://www.instagram.com/malook.official/" className="social-icon" target="_blank" title="Instagram">
                  <i className="icon-instagram" />
                </a>
               
              </div>
              {/* End .social-icons */}
            </div>
            {/* End .mobile-menu-wrapper */}
          </div>















          <div className="mobile-menu-container1" id="menu-mobile-2" onClick={()=>setDisplayMenu3()}>
            <div className="mobile-menu-wrapper1">
              {/* End .social-icons */}
            </div>
            {/* End .mobile-menu-wrapper */}
          </div>













          {/* End .mobile-menu-container */}
          {/* Sign in / Register Modal */}
          <div className="modal fade" id="signin-modal" tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body">
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                      <i className="icon-close" />
                    </span>
                  </button>
                  <div className="form-box">
                    <div className="form-tab">
                      <ul className="nav nav-pills nav-fill" role="tablist">
                        <li className="nav-item">
                          <a className="nav-link font-size-normal second-primary-color active" id="signin-tab" data-toggle="tab" href="#signin" role="tab" aria-controls="signin" aria-selected="true">Sign In</a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link font-size-normal second-primary-color" id="register-tab" data-toggle="tab" href="#register" role="tab" aria-controls="register" aria-selected="false">Register</a>
                        </li>
                      </ul>
                      <div className="tab-content" id="tab-content-5">
                        <div className="tab-pane fade show active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                          <form action="#">
                            <div className="form-group">
                              <label htmlFor="singin-email">Username or email address *</label>
                              <input type="text" className="form-control" id="singin-email" name="singin-email" required />
                            </div>
                            {/* End .form-group */}
                            <div className="form-group">
                              <label htmlFor="singin-password">Password *</label>
                              <input type="password" className="form-control" id="singin-password" name="singin-password" required />
                            </div>
                            {/* End .form-group */}
                            <div className="form-footer">
                              <button type="submit" className="btn btn-outline-primary-2">
                                <span>LOG IN</span>
                                <i className="icon-long-arrow-right" />
                              </button>
                              <div className="custom-control custom-checkbox">
                                <input type="checkbox" className="custom-control-input" id="signin-remember" />
                                <label className="custom-control-label" htmlFor="signin-remember">Remember Me</label>
                              </div>
                              {/* End .custom-checkbox */}
                              <span className="forgot-link">Forgot Your Password?</span>
                            </div>
                            {/* End .form-footer */}
                          </form>
                          <div className="form-choice">
                            <p className="text-center">or sign in with</p>
                            <div className="row">
                              <div className="col-sm-6">
                                <span className="btn btn-login btn-g">
                                  <i className="icon-google" />
                                  Login With Google
                                </span>
                              </div>
                              {/* End .col-6 */}
                              <div className="col-sm-6">
                                <span className="btn btn-login btn-f">
                                  <i className="icon-facebook-f" />
                                  Login With Facebook
                                </span>
                              </div>
                              {/* End .col-6 */}
                            </div>
                            {/* End .row */}
                          </div>
                          {/* End .form-choice */}
                        </div>
                        {/* .End .tab-pane */}
                        <div className="tab-pane fade" id="register" role="tabpanel" aria-labelledby="register-tab">
                          <form action="#">
                            <div className="form-group">
                              <label htmlFor="register-email">Your email address *</label>
                              <input type="email" className="form-control" id="register-email" name="register-email" required />
                            </div>
                            {/* End .form-group */}
                            <div className="form-group">
                              <label htmlFor="register-password">Password *</label>
                              <input type="password" className="form-control" id="register-password" name="register-password" required />
                            </div>
                            {/* End .form-group */}
                            <div className="form-footer">
                              <button type="submit" className="btn btn-outline-primary-2">
                                <span>SIGN UP</span>
                                <i className="icon-long-arrow-right" />
                              </button>
                              <div className="custom-control custom-checkbox">
                                <input type="checkbox" className="custom-control-input" id="register-policy" required />
                                <label className="custom-control-label" htmlFor="register-policy">I agree to the
                                  <span>privacy policy</span> *</label>
                              </div>
                              {/* End .custom-checkbox */}
                            </div>
                            {/* End .form-footer */}
                          </form>
                          <div className="form-choice">
                            <p className="text-center">or sign in with</p>
                            <div className="row">
                              <div className="col-sm-6">
                                <span className="btn btn-login btn-g">
                                  <i className="icon-google" />
                                  Login With Google
                                </span>
                              </div>
                              {/* End .col-6 */}
                              <div className="col-sm-6">
                                <span className="btn btn-login  btn-f">
                                  <i className="icon-facebook-f" />
                                  Login With Facebook
                                </span>
                              </div>
                              {/* End .col-6 */}
                            </div>
                            {/* End .row */}
                          </div>
                          {/* End .form-choice */}
                        </div>
                        {/* .End .tab-pane */}
                      </div>
                      {/* End .tab-content */}
                    </div>
                    {/* End .form-tab */}
                  </div>
                  {/* End .form-box */}
                </div>
                {/* End .modal-body */}
              </div>
              {/* End .modal-content */}
            </div>
            {/* End .modal-dialog */}
          </div>
          {/* End .modal */}
              {/* End .header-bottom */}






              <div className="header-middle header-middle11" style={{borderTop:"1px solid grey"}}>
                <div className="container" style={{width:"100%",margin:"auto",justifyContent:"center"}}>

<div class="change-fag" style={{}}>

<div class="header123" style={{    margin: "auto",
   width:"100%"}}>
                          <div class="header123-right" style={{margin:"auto",width:"100%"}}>
            {/* <Link to="/">Home</Link>
            <Link to="/about">About Us</Link> */}
            {MainCatogories.map((res,i)=>{
              return(
                <a href={"/categories/"+res.MainCategories+"/all-products"}>{res.MainCategories}</a>

              )

            })

          }
            

            {/* <Link to="/Corporate-Equiries">Corporate Enquiries</Link>
              <Link to="/clients">Our Clients</Link> */}
            {/* <Link to="/contact">Contact Us </Link> */}


        </div>
        </div>
        </div>
        </div>
        </div>








            </header>

        </>
        )
}

export default Header;









